import get from 'lodash.get';

const getPublishedSiteVhosts = (rootState) =>
  get(rootState, 'site.publishedSiteData.vhostNames', null);

export default getPublishedSiteVhosts;
